/* BABY IN WOOD — aperçu du prénom (fiche produit). Script commun mis en cache par le navigateur ; chaque instance s'initialise via window.biwNPQ.push(id). */
(function(){
  "use strict";
  function init(UID){
  var root = document.getElementById('biw-np-' + UID);
  if (!root || root.dataset.init) return;
  root.dataset.init = '1';

  var CFG = {
    mode:   root.dataset.mode,
    anchor: root.dataset.anchor,
    bx: parseFloat(root.dataset.bx), by: parseFloat(root.dataset.by),
    bsize: parseFloat(root.dataset.bsize), brot: parseFloat(root.dataset.brot),
    gx: parseFloat(root.dataset.gx), gy: parseFloat(root.dataset.gy),
    gsize: parseFloat(root.dataset.gsize), grot: parseFloat(root.dataset.grot),
    scale: parseFloat(root.dataset.scale)||0, haut: parseFloat(root.dataset.haut)||0,
    decorw: parseFloat(root.dataset.decorw)||0,
    realcm: parseFloat(root.dataset.realcm)||50,
    decorpct: parseFloat(root.dataset.decorpct)||100,
    refcm: parseFloat(root.dataset.refcm)||0, refpct: parseFloat(root.dataset.refpct)||0,
    decx: parseFloat(root.dataset.decx)||50, decy: parseFloat(root.dataset.decy)||52
  };
  var SCENE = root.dataset.scene === '1';
  var REFAXIS = root.dataset.refaxis || 'w';
  var BGPNG = root.dataset.bgpng === '1';
  var COLOR = root.dataset.color === '1', BGSIZE = parseFloat(root.dataset.bgsize) || 68;   /* fiche prénom : fond coloré, prénom en grand */
  var ZOOM_ON = root.dataset.zoom !== '0', ZOOM_MAX = (parseFloat(root.dataset.zoommax) || 190) / 100, DESIGN = root.dataset.design === '1';
  var ZOOM_LBL_OUT = root.dataset.zoomout || 'Voir toute la chambre', ZOOM_LBL_IN = root.dataset.zoomin || 'Zoomer sur le décor';
  var zoomEl = document.getElementById('biw-np-zoom-' + UID), zoomBtn = document.getElementById('biw-np-zoombtn-' + UID), zoomOut = false;
  if (zoomBtn) zoomBtn.addEventListener('click', function(){ zoomOut = !zoomOut; render(); });

  /* boîte OPAQUE d'un PNG détouré (les marges transparentes fausseraient l'échelle :
     un singe qui n'occupe que 70 % de son fichier s'afficherait 30 % trop petit).
     Même principe que le studio « Voir sur mon mur ». */
  /* Analyse d'un visuel détouré : boîte opaque + orientation (moments d'inertie de la partie opaque).
     → {W,H : px naturels ; x,y,w,h : boîte en fractions 0..1 ; phi : angle de l'axe principal (° depuis l'horizontale,
        sens horaire à l'écran) ; elong : allongement (1 = rond, grand = fin et long)} ou null. */
  function biwDecorFit(im){
    try{
      if(!im||!im.naturalWidth||!im.naturalHeight) return null;
      var W=im.naturalWidth, H=im.naturalHeight, S=260, sc=Math.min(1,S/Math.max(W,H));
      var c=document.createElement('canvas'); c.width=Math.max(1,Math.round(W*sc)); c.height=Math.max(1,Math.round(H*sc));
      var cx=c.getContext('2d'); cx.drawImage(im,0,0,c.width,c.height);
      var d=cx.getImageData(0,0,c.width,c.height).data, w=c.width, h=c.height;
      var x0=w,y0=h,x1=-1,y1=-1,n=0,sx=0,sy=0,sxx=0,syy=0,sxy=0;
      for(var y=0;y<h;y++){ for(var x=0;x<w;x++){ var i=(y*w+x)*4; if(d[i+3]>16 && !(d[i]>245&&d[i+1]>245&&d[i+2]>245)){ if(x<x0)x0=x; if(x>x1)x1=x; if(y<y0)y0=y; if(y>y1)y1=y; n++; sx+=x; sy+=y; sxx+=x*x; syy+=y*y; sxy+=x*y; } } }
      if(x1<0||n<20) return null;
      var mx=sx/n, my=sy/n, uxx=sxx/n-mx*mx, uyy=syy/n-my*my, uxy=sxy/n-mx*my;
      var phi=0.5*Math.atan2(2*uxy, uxx-uyy)*180/Math.PI;
      var tr=(uxx+uyy)/2, dt=Math.sqrt(Math.max(0,((uxx-uyy)/2)*((uxx-uyy)/2)+uxy*uxy));
      return {W:W,H:H,x:x0/w,y:y0/h,w:(x1-x0+1)/w,h:(y1-y0+1)/h,phi:phi,elong:(tr+dt)/Math.max(1e-6,tr-dt)};
    }catch(e){ return null; }
  }
  /* Encombrement au mur d'un décor dont les cotes (Wcm × Hcm) sont données DROITES alors que le visuel peut être incliné
     (ex. la fusée photographiée en biais). → {bw, bh : largeur/hauteur réellement occupées (cm) ; deg : inclinaison}.
     Un visuel droit, ou pas assez allongé pour trancher, garde exactement les cotes déclarées. */
  function biwFootprint(Wcm, Hcm, fit){
    var r={bw:Wcm||0, bh:Hcm||0, deg:0};
    if(!fit||!(Wcm>0)||!(Hcm>0)) return r;
    var deg=fit.phi-((Hcm>=Wcm)?90:0); while(deg>90) deg-=180; while(deg<=-90) deg+=180;
    if(fit.elong<1.8||Math.abs(deg)<8) return r;
    /* un visuel DROIT a le même rapport largeur/hauteur que les cotes déclarées (le marchand mesure la boîte du décor) :
       on ne conclut à une inclinaison que si le rapport mesuré s'en écarte d'au moins 1,5× (fusée : 3,6×) */
    var rm=(fit.w*fit.W)/(fit.h*fit.H), qd=rm/(Wcm/Hcm);
    if(qd<1.5&&qd>0.6667) return r;
    var t=deg*Math.PI/180, c=Math.abs(Math.cos(t)), s=Math.abs(Math.sin(t));
    var bw=Wcm*c+Hcm*s, bh=Wcm*s+Hcm*c, rp=bw/bh;
    if(rp/rm>1.35||rm/rp>1.35) return r;
    return {bw:bw, bh:bh, deg:deg};
  }
  function biwOpaqueBox(im){
    var f = biwDecorFit(im); if (!f || f.w < 0.2) return null;
    return { w: f.w, h: f.h, minx: f.x, miny: f.y, W: f.W, H: f.H, phi: f.phi, elong: f.elong };
  }
  var DECBOX = null, PHBOX = null;
  var decorImg = document.getElementById('biw-np-decor-' + UID);
  if (decorImg){
    var _md = function(){ DECBOX = biwOpaqueBox(decorImg); render(); };
    if (decorImg.complete && decorImg.naturalWidth){ DECBOX = biwOpaqueBox(decorImg); }
    decorImg.addEventListener('load', _md);
  }
  /* via root : « stage » est déclaré plus bas (var hoisting → undefined ici), ce qui
     empêchait TOUTE mesure PHBOX → échelle fausse en mode plein-cadre automatique */
  var photoEl = root.querySelector('.biw-np__photo');
  if (photoEl && BGPNG){
    var _mp = function(){ PHBOX = biwOpaqueBox(photoEl); render(); };
    if (photoEl.complete && photoEl.naturalWidth){ PHBOX = biwOpaqueBox(photoEl); }
    photoEl.addEventListener('load', _mp);
  }
  var MAX = parseInt(root.dataset.max, 10) || 14;
  var FORCE_CENTER = root.dataset.center === '1';   /* fiche prénom : prénom centré dans l'aperçu */

  var input   = document.getElementById('biw-np-input-'    + UID);
  var count   = document.getElementById('biw-np-count-'    + UID);
  var note    = document.getElementById('biw-np-note-'     + UID);
  var badge   = document.getElementById('biw-np-badge-'    + UID);
  var stage   = document.getElementById('biw-np-stage-'    + UID);
  var svg     = document.getElementById('biw-np-wood-'     + UID);
  var svgText = document.getElementById('biw-np-woodtext-' + UID);
  var svgStroke = document.getElementById('biw-np-woodstroke-' + UID);
  var engrave = document.getElementById('biw-np-engrave-'  + UID);
  var elemImg = document.getElementById('biw-np-elem-'     + UID);
  var elemsEl = document.getElementById('biw-np-elems-'    + UID);
  var ELEMS   = [];
  try { ELEMS = JSON.parse((elemsEl && elemsEl.textContent) || '[]') || []; } catch(e){ ELEMS = []; }
  var FIXEDEL = '';
  (function(){ var f = document.getElementById('biw-np-fixel-' + UID);
    if (f){ try { FIXEDEL = JSON.parse(f.textContent) || ''; } catch(e){ FIXEDEL = ''; } } })();

  var VARIANTS = {};
  try { VARIANTS = JSON.parse(document.getElementById('biw-np-variants-' + UID).textContent) || {}; } catch(e){ VARIANTS = {}; }
  function modeOfTitle(t){
    if (!t) return 'off';
    var s = t.toLowerCase();
    if (s.indexOf('sans pr') !== -1) return 'off';
    var hasName = s.indexOf('prénom') !== -1 || s.indexOf('prenom') !== -1;
    if (!hasName && s.indexOf('grav') === -1) return 'off';
    if (s.indexOf('bois') !== -1) return 'bois';
    if (s.indexOf('grav') !== -1) return 'gravure';
    return 'bois';
  }

  var hasNameVariant = false;
  for (var k in VARIANTS){ if (modeOfTitle(VARIANTS[k]) !== 'off') hasNameVariant = true; }

  function scope(){ return root.closest('.shopify-section') || document; }
  function productForms(){
    var all = scope().querySelectorAll('form[action*="/cart/add"]'), out = [];
    for (var i=0;i<all.length;i++){ if (!all[i].hasAttribute('data-biw-upsell')) out.push(all[i]); }
    return out;
  }
  function mainForm(){
    var btn = scope().querySelector('[data-product-add-to-cart-button], #AddToCart');
    var f = btn && btn.closest('form[action*="/cart/add"]');
    if (f) return f;
    var pf = productForms(); return pf[0] || null;
  }
  function currentVariantId(){
    var f = mainForm();
    var el = f && f.querySelector('[name="id"]');
    if (el && el.value) return String(el.value);
    try { return new URL(window.location.href).searchParams.get('variant') || ''; }
    catch(e){ return ''; }
  }
  var forcedMode = null; /* piloté de l'extérieur (toggle « prénom en bois ») via biw:np-force */
  function currentMode(){
    if (forcedMode === 'off' || forcedMode === 'bois' || forcedMode === 'gravure') return forcedMode;
    if (CFG.mode === 'bois' || CFG.mode === 'gravure') {
      /* mode forcé dans l'éditeur : actif seulement si la variante le permet */
      if (!hasNameVariant) return CFG.mode;
      return modeOfTitle(VARIANTS[currentVariantId()]) === 'off' ? 'off' : CFG.mode;
    }
    if (!hasNameVariant) return 'gravure';   /* gravure incluse d'office */
    return modeOfTitle(VARIANTS[currentVariantId()]);
  }

  function setPrenom(val){
    productForms().forEach(function(f){
      var h = f.querySelector('input[name="properties[Prénom]"]');
      if (val === '' || val == null){ if (h) h.value = ''; return; }
      if (!h){ h = document.createElement('input'); h.type = 'hidden'; h.name = 'properties[Prénom]'; f.appendChild(h); }
      h.value = val;
    });
  }

  function clean(v){ return v.replace(/[^\p{L}\p{M}'\- ]/gu, '').slice(0, MAX); }

  /* ÉCRITURE (police du prénom) : boutons → police du SVG bois et de la gravure + propriété de commande */
  var FONT = { name: 'Sacramento', fam: "'Sacramento BIW', Sacramento, cursive", w: '400' };
  var fontsWrap = document.getElementById('biw-np-fonts-' + UID);
  var HAS_FONTS = !!fontsWrap;
  function setEcriture(val){
    productForms().forEach(function(f){
      var h = f.querySelector('input[name="properties[Écriture]"]');
      if (val === '' || val == null){ if (h) h.value = ''; return; }
      if (!h){ h = document.createElement('input'); h.type = 'hidden'; h.name = 'properties[Écriture]'; f.appendChild(h); }
      h.value = val;
    });
  }
  function applyFont(){
    if (svgText){ svgText.setAttribute('font-family', FONT.fam); svgText.setAttribute('font-weight', FONT.w); }
    if (svgStroke){ svgStroke.setAttribute('font-family', FONT.fam); svgStroke.setAttribute('font-weight', FONT.w); svgStroke.setAttribute('stroke-width', FONT.sw || '7'); }
    if (engrave){ engrave.style.fontFamily = FONT.fam; engrave.style.fontWeight = FONT.w; }
  }
  if (fontsWrap){
    fontsWrap.addEventListener('click', function(e){
      var b = e.target.closest('.biw-np__fbtn'); if (!b) return;
      FONT = { name: b.getAttribute('data-font'), fam: b.getAttribute('data-fam'), w: b.getAttribute('data-w') || '400', sw: b.getAttribute('data-sw') || '7' };
      var all = fontsWrap.querySelectorAll('.biw-np__fbtn');
      for (var i = 0; i < all.length; i++){ var on = all[i] === b; all[i].classList.toggle('on', on); all[i].setAttribute('aria-checked', on ? 'true' : 'false'); }
      applyFont();
      if (document.fonts && document.fonts.load){ document.fonts.load('200px ' + FONT.fam.split(',')[0].replace(/'/g, '')).then(render).catch(render); }
      render();
    });
  }

  function drawWood(text){
    svgText.textContent = text;
    if (svgStroke) svgStroke.textContent = text;
    var bb;
    try { bb = svgText.getBBox(); } catch(e){ return; }
    if (!bb || !bb.width) return;

    /* marges sur la LARGEUR → constantes à l'écran → aucun glissement vertical
       (+8 : place pour le contour épais et l'ombre, sinon rognés au bord) */
    var padX = bb.width * 0.08 + 14;
    var padY = bb.width * 0.10 + 14;
    var vbW = bb.width + padX*2;
    svg.setAttribute('viewBox',
      (bb.x - padX) + ' ' + (bb.y - padY) + ' ' +
      vbW + ' ' + (bb.height + padY*2));
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');

    /* À L'ÉCHELLE : le prénom fait sa VRAIE largeur (realcm, 50 ou 70 cm) par rapport au
       décor XL de référence sur la photo. Le décor mesure `haut` cm en vrai et occupe
       `decorpct` % de la HAUTEUR de la photo → on en déduit les px/cm, donc la largeur
       exacte du prénom. On compense la marge du viewBox pour que le GLYPHE (et non la boîte)
       fasse la bonne taille. Hauteur libre = échelle uniforme. POINT FIXE : centré en (bx,by). */
    var toScale = CFG.scale && stage.clientWidth && stage.clientHeight
                  && (SCENE || CFG.decorw > 0 || (CFG.haut > 0 && CFG.decorpct > 0));
    if (toScale){
      /* dimensions RÉELLEMENT affichées de la photo (formule « contain » sur ses
         dimensions naturelles) : exact pour toute photo — carrée, paysage, portrait */
      var ph = stage.querySelector('.biw-np__photo');
      var dispW = stage.clientWidth, dispH = stage.clientHeight;
      if (ph && ph.naturalWidth && ph.naturalHeight){
        var k = Math.min(stage.clientWidth / ph.naturalWidth, stage.clientHeight / ph.naturalHeight);
        dispW = ph.naturalWidth * k;
        dispH = ph.naturalHeight * k;
      }
      var pxPerCm;
      if (SCENE && CFG.refcm > 0 && CFG.refpct > 0){
        /* SCÈNE : le repère réglé dans l'éditeur donne l'échelle de la photo de chambre.
           Il peut être mesuré en LARGEUR (commode…) ou en HAUTEUR (lit cabane, porte…). */
        var refBase = (REFAXIS === 'h') ? dispH : dispW;
        pxPerCm = (CFG.refpct/100 * refBase) / CFG.refcm;
      } else if (CFG.decorw > 0){
        /* AUTOMATIQUE plein cadre : le SUJET du visuel détouré (marges transparentes
           déduites via PHBOX) fait « Largeur réelle » cm → px/cm exact */
        var phFill = PHBOX ? PHBOX.w : 1;
        pxPerCm = (dispW * phFill) / (PHBOX ? biwFootprint(CFG.decorw, CFG.haut, PHBOX).bw : CFG.decorw);
      } else {
        pxPerCm = (CFG.decorpct/100 * stage.clientHeight) / CFG.haut;
      }
      var glyphPx = (CFG.realcm_cur || CFG.realcm) * pxPerCm;   /* largeur voulue du glyphe (px) */

      /* SCÈNE : incruste le décor à sa taille réelle (marges du PNG compensées) et pose
         le prénom JUSTE AU-DESSUS du sujet */
      if (SCENE && decorImg && CFG.decorw > 0){
        var dfw = DECBOX ? DECBOX.w : 1;
        var subjW = (DECBOX ? biwFootprint(CFG.decorw, CFG.haut, DECBOX).bw : CFG.decorw) * pxPerCm;   /* largeur réellement occupée par le SUJET (visuel incliné compris), en px */
        var imgW  = subjW / dfw;                   /* largeur de l'IMG, marges comprises */
        decorImg.style.width = imgW + 'px';
        decorImg.style.left  = CFG.decx + '%';
        decorImg.style.top   = CFG.decy + '%';
        var imgH = decorImg.naturalWidth ? imgW * decorImg.naturalHeight / decorImg.naturalWidth : imgW;
        var subjTopPx = (CFG.decy/100 * stage.clientHeight) - imgH/2 + (DECBOX ? DECBOX.miny : 0) * imgH;
        var glyphH = glyphPx * (bb.height / bb.width);
        var topPx = subjTopPx - glyphH/2 - 10;
        CFG.nameCx = CFG.decx;
        CFG.nameCy = Math.max(7, topPx / stage.clientHeight * 100);
        /* ZOOM AUTOMATIQUE : décor + prénom occupent ~62 % de la largeur de l'aperçu (échelle entre eux intacte) ;
           l'origine du zoom est le centre du groupe, donc rien ne sort de la photo ; bouton pour revoir toute la chambre */
        if (zoomEl){
          var gw = Math.max(subjW, glyphPx), z = (ZOOM_ON && !DESIGN) ? Math.min(ZOOM_MAX, Math.max(1, (0.62 * stage.clientWidth) / gw)) : 1;
          var subjBottomPx = subjTopPx + (DECBOX ? DECBOX.h : 1) * imgH, nameTopPx = topPx - glyphH/2;
          var oy = ((nameTopPx + subjBottomPx) / 2) / stage.clientHeight * 100;
          zoomEl.style.transformOrigin = CFG.decx + '% ' + Math.max(0, Math.min(100, oy)) + '%';
          zoomEl.style.transform = (z > 1.02 && !zoomOut) ? 'scale(' + z.toFixed(3) + ')' : 'none';
          if (zoomBtn){ zoomBtn.hidden = !(z > 1.02); zoomBtn.textContent = zoomOut ? ZOOM_LBL_IN : ZOOM_LBL_OUT; }
        }
      }
      var boxPx   = glyphPx * (vbW / bb.width);                 /* largeur de la boîte SVG (marge incluse) */
      svg.style.width     = (boxPx / stage.clientWidth * 100) + '%';
      svg.style.maxWidth  = 'none';
      svg.style.height    = 'auto';
      svg.style.maxHeight = 'none';
    } else {
      /* pas de calibrage métachamp : on fait quand même GRANDIR / RÉTRÉCIR le prénom
         selon la taille choisie (ex. 70 cm = 1,4× plus grand que 50 cm), automatiquement,
         sans aucun réglage à faire. f = taille de la variante ÷ taille de référence. */
      var f = 1;
      if (CFG.realcm > 0 && CFG.realcm_cur) f = CFG.realcm_cur / CFG.realcm;
      var w = (COLOR ? BGSIZE : CFG.bsize) * f;
      svg.style.width     = w + '%';
      svg.style.maxWidth  = w + '%';
      svg.style.height    = 'auto';
      svg.style.maxHeight = (42 * f) + '%';
      /* ZOOM AUTOMATIQUE (fiche prénom, sur la photo de la chambre) : on se rapproche du prénom, qui garde
         sa taille réelle par rapport à la pièce — même principe que sur les décors XL. Le facteur est calculé
         sur la taille de RÉFÉRENCE (50 cm) et non sur la variante en cours : l'écart visuel entre 50 et 70 cm
         est donc conservé (le 70 cm reste 1,4 fois plus large que le 50 cm, zoom compris). */
      if (zoomEl && !SCENE){
        var zb = COLOR ? BGSIZE : CFG.bsize;
        var zcap = (CFG.elemSpan > 0) ? (96 / CFG.elemSpan) : 99;   /* petits éléments choisis : ils doivent rester ENTIERS dans le cadre */
        var zf = (ZOOM_ON && !DESIGN && zb > 0 && w > 0) ? Math.max(1, Math.min(ZOOM_MAX, 62 / zb, 86 / w, zcap)) : 1;
        if (zf < 1.15) zf = 1;                                       /* un zoom de quelques pour cent ne sert à rien et ferait clignoter le bouton */
        var zox = (CFG.nameCx != null ? CFG.nameCx : (50 + (CFG.bx || 0)));
        var zoy = (CFG.nameCy != null ? CFG.nameCy : CFG.by);
        zoomEl.style.transformOrigin = zox + '% ' + zoy + '%';
        zoomEl.style.transform = (zf > 1.02 && !zoomOut) ? 'scale(' + zf.toFixed(3) + ')' : 'none';
        if (zoomBtn){ zoomBtn.hidden = !(zf > 1.02); zoomBtn.textContent = zoomOut ? ZOOM_LBL_IN : ZOOM_LBL_OUT; }
      }
    }
    svg.style.left     = (CFG.nameCx != null ? CFG.nameCx : (50 + (CFG.bx || 0))) + '%';
    svg.style.top      = (CFG.nameCy != null ? CFG.nameCy : CFG.by) + '%';
    svg.style.transform = 'translate(-50%,-50%) rotate(' + (CFG.brot || 0) + 'deg)';
    /* contour adaptatif : à petite taille (prénom à l'échelle dans la chambre) un trait trop fin disparaît et les lettres
       fines (l, t…) semblent coupées ; on garantit ~1,4 px à l'écran, sans dépasser 9 unités pour ne pas boucher les lettres */
    if (svgStroke){ var rw = svg.getBoundingClientRect().width, scl = (rw && vbW) ? rw / vbW : 0, base = parseFloat(FONT.sw) || 7, need = scl > 0 ? 1.4 / scl : 0; svgStroke.setAttribute('stroke-width', Math.max(base, Math.min(need, 9)).toFixed(2)); }
  }

  /* largeur réelle du prénom selon la variante « Taille » (ex. « 70 cm / Nœuds ») */
  function realCmOf(title){
    if (!title) return CFG.realcm;
    var m = String(title).match(/(\d+(?:[.,]\d+)?)\s*cm/i);
    return m ? parseFloat(m[1].replace(',', '.')) : CFG.realcm;
  }

  function drawEngrave(text){
    engrave.textContent = text;
    engrave.style.left = (50 + (CFG.gx || 0)) + '%';
    engrave.style.top  = CFG.gy + '%';
    engrave.style.fontSize = (stage.clientWidth * (CFG.gsize / 5) / 100) + 'px';
    engrave.style.transform = 'translate(-50%,-50%) rotate(' + (CFG.grot || 0) + 'deg)';
  }

  /* ÉLÉMENT choisi : on lit le titre de la variante sélectionnée (ex. « 50 cm / Papillons »),
     on cherche le morceau qui correspond à un bloc « Élément (aperçu) », et on superpose son
     image à côté du prénom. Rien à trouver / « Sans » → aucun élément affiché. */
  /* normalisation tolérante : ignore accents, majuscules et espaces en trop
     → si l'option s'appelle « Étoiles » et le bloc « etoiles », ça marche quand même */
  function _norm(s){
    s = String(s == null ? '' : s);
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.toLowerCase().trim();
  }
  function selectedElem(){
    if (!ELEMS.length) return null;
    if (FIXEDEL){
      var fx = _norm(FIXEDEL);
      for (var k=0;k<ELEMS.length;k++){
        if (ELEMS[k].m && _norm(ELEMS[k].m) === fx) return ELEMS[k];
      }
      return null;
    }
    var t = VARIANTS[currentVariantId()] || '';
    var parts = String(t).split('/');
    for (var i=0;i<parts.length;i++){
      var p = _norm(parts[i]);
      if (!p) continue;
      for (var j=0;j<ELEMS.length;j++){
        if (ELEMS[j].m && _norm(ELEMS[j].m) === p) return ELEMS[j];
      }
    }
    return null;
  }
  function drawElem(el){
    if (!elemImg) return;
    /* encombrement du calque d'éléments, en % de la LARGEUR du cadre (la hauteur est libre) :
       le zoom s'en sert pour ne jamais rogner les papillons, nuages, pattes de dinosaure… */
    CFG.elemSpan = 0;
    if (el && el.img){
      if (elemImg.getAttribute('src') !== el.img) elemImg.setAttribute('src', el.img);
      elemImg.style.left      = el.x + '%';
      elemImg.style.top       = el.y + '%';
      elemImg.style.width     = el.s + '%';
      elemImg.style.transform = 'translate(-50%,-50%) rotate(' + (el.r || 0) + 'deg)';
      elemImg.classList.add('is-on');
      var _eh = (elemImg.naturalWidth > 0) ? el.s * (elemImg.naturalHeight / elemImg.naturalWidth) : el.s;
      CFG.elemSpan = Math.max(el.s || 0, _eh);
    } else {
      elemImg.classList.remove('is-on');
    }
  }

  function render(){
    if (zoomEl) zoomEl.style.transform = 'none';
    if (zoomBtn) zoomBtn.hidden = true;
    var v = clean(input.value);
    if (v !== input.value) input.value = v;
    /* champ obligatoire dès qu'un prénom est attendu (gravure, ou option « prénom en bois » choisie) */
    try { input.required = (currentMode() !== 'off'); input.setAttribute('aria-required', input.required ? 'true' : 'false'); } catch(err){}
    count.textContent = v.length;

    var shown = v.trim() === '' ? 'Maël' : v;
    var mode  = currentMode();

    /* Le FOND est fixe (métachamp custom.apercu_image → réglage bloc → Liquid).
       On ne remplace JAMAIS le fond par l'image de la variante : les éléments
       autour du prénom s'affichent en surcouche (drawElem / .biw-np__elem). */

    root.classList.toggle('mode-bois',    mode === 'bois');
    root.classList.toggle('mode-gravure', mode === 'gravure');
    root.classList.toggle('is-off',       mode === 'off');

    /* élément choisi + CENTRE du prénom :
       - défaut : réglages du bloc (bx, by)
       - fiche prénom (center) : prénom centré dans l'aperçu
       - élément « autour » choisi : le prénom tombe PILE au centre de l'ensemble
         (même point que le cadre d'éléments → centrage garanti, aucun réglage à faire) */
    var _el = (mode === 'bois') ? selectedElem() : null;
    CFG.nameCx = 50 + (CFG.bx || 0);
    CFG.nameCy = CFG.by;
    if (CFG.decorw > 0 && !FORCE_CENTER && !SCENE){ CFG.nameCy = 12; }  /* AUTO plein cadre : prénom AU-DESSUS du décor */
    if (FORCE_CENTER){ CFG.nameCx = 50; CFG.nameCy = 50; }
    if (_el && _el.lay !== 'beside'){ CFG.nameCx = _el.x; CFG.nameCy = _el.y; }
    drawElem(_el);

    if (mode === 'bois'){
      CFG.realcm_cur = realCmOf(VARIANTS[currentVariantId()]);
      drawWood(shown);
      var _cm = CFG.realcm_cur || CFG.realcm;
      badge.textContent = 'Prénom en bois · ~' + _cm + ' cm';
      note.textContent  = v ? 'À titre indicatif — le prénom fait env. ' + _cm + ' cm de large, découpé dans du contreplaqué de tilleul.'
                            : 'Écrivez le prénom pour le voir apparaître au mur.';
    } else if (mode === 'gravure'){
      drawEngrave(shown);
      badge.textContent = 'Gravure offerte';
      note.textContent  = v ? 'À titre indicatif — aperçu du prénom gravé au laser dans le bois.'
                            : 'Écrivez le prénom pour le voir gravé.';
    } else {
      badge.textContent = 'Option prénom';
      note.textContent  = 'Ajoutez l\u2019option prénom pour le voir apparaître au mur.';
    }

    setPrenom((mode === 'off') ? '' : v.trim());
    if (HAS_FONTS){
      setEcriture((mode === 'off') ? '' : FONT.name);
      var samples = fontsWrap.querySelectorAll('.biw-np__fs');
      for (var si = 0; si < samples.length; si++){
        var sp = samples[si]; sp.textContent = v.trim() || 'Louise'; sp.style.fontSize = '';
        /* le prénom doit tenir dans la tuile : on réduit la taille au lieu de couper les lettres */
        var fs = 24; while (sp.scrollWidth > sp.clientWidth + 1 && fs > 13){ fs -= 1; sp.style.fontSize = fs + 'px'; }
      }
    }
    if (v.trim() !== '') root.classList.remove('is-error');
  }

  if (elemImg) elemImg.addEventListener('load', render);   /* la taille réelle du calque n'est connue qu'au chargement */
  input.addEventListener('input', render);
  window.addEventListener('resize', render);

  /* teaser (décors XL, « Sans prénom ») : cliquer sélectionne la variante « Avec le prénom » → l'aperçu se déplie */
  var teaser = document.getElementById('biw-np-teaser-' + UID);
  if (teaser){
    teaser.addEventListener('click', function(){
      var sc = scope();
      var radios = sc.querySelectorAll('.var__radio');
      for (var i = 0; i < radios.length; i++){
        var lab = sc.querySelector('label[for="' + radios[i].id + '"]');
        var t = ((lab ? lab.textContent : '') + ' ' + (radios[i].value || '')).toLowerCase();
        if (t.indexOf('sans') === -1 && (t.indexOf('bois') !== -1 || t.indexOf('avec') !== -1)){ radios[i].click(); break; }
      }
      setTimeout(render, 60);
      var inp = document.getElementById('biw-np-input-' + UID);
      if (inp) setTimeout(function(){ inp.focus(); }, 120);
    });
  }
  /* l'aperçu est en lazy-load : re-calculer l'échelle une fois la photo chargée */
  var npPhoto = stage.querySelector('.biw-np__photo');
  if (npPhoto && npPhoto.tagName === 'IMG'){
    if (npPhoto.complete && npPhoto.naturalWidth) setTimeout(render, 0);
    npPhoto.addEventListener('load', render);
  }
  document.addEventListener('biw:np-force', function(e){
    forcedMode = (e && e.detail) ? e.detail : null;
    render();
  });
  var f = mainForm();
  if (f) f.addEventListener('change', function(){ setTimeout(render, 30); });
  window.addEventListener('popstate', function(){ setTimeout(render, 30); });

  /* blocage de l'ajout au panier si l'option prénom est prise mais le champ vide */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1 || form.hasAttribute('data-biw-upsell')) return;
    if (productForms().indexOf(form) === -1) return;
    render();
    if (currentMode() !== 'off' && input.value.trim() === ''){
      e.preventDefault(); e.stopPropagation();
      root.classList.add('is-error');
      note.textContent = 'Merci d\u2019indiquer le prénom 🌿';
      (root.getClientRects().length ? root : stage).scrollIntoView({ behavior:'smooth', block:'center' });
      input.focus();
    }
  }, true);

  /* ───── MODE CALAGE GRAVURE (le bouton n'existe que dans l'éditeur de thème) ─────
     Glisser la gravure = position (gx/gy en % de la scène), curseurs = taille/rotation.
     Les valeurs modifient CFG en direct (render) et s'affichent prêtes à coller dans
     les métachamps gravure_x / gravure_y / gravure_size / gravure_rotation. */
  var calBtn = document.getElementById('biw-np-calbtn-' + UID);
  if (calBtn && engrave && stage){
    var calPanel = document.getElementById('biw-np-cal-' + UID);
    var calVals  = document.getElementById('biw-np-calv-' + UID);
    var calSize  = document.getElementById('biw-np-cal-size-' + UID);
    var calRot   = document.getElementById('biw-np-cal-rot-' + UID);
    var calCopy  = document.getElementById('biw-np-calcopy-' + UID);
    var calR1 = function(n){ return Math.round((n || 0) * 10) / 10; };
    var calShow = function(){
      calVals.textContent = 'gravure_x = ' + calR1(CFG.gx) + '    gravure_y = ' + calR1(CFG.gy) +
        '    gravure_size = ' + calR1(CFG.gsize) + '    gravure_rotation = ' + calR1(CFG.grot);
      calSize.value = CFG.gsize || 42; calRot.value = CFG.grot || 0;
    };
    calBtn.addEventListener('click', function(){
      var on = calPanel.hidden;
      calPanel.hidden = !on;
      root.classList.toggle('biw-np--cal', on);
      calBtn.textContent = on ? '✅ Terminer le calage' : '🎯 Caler la gravure';
      if (on) calShow();
    });
    var calDrag = null;
    engrave.addEventListener('pointerdown', function(e){
      if (!root.classList.contains('biw-np--cal')) return;
      calDrag = { x: e.clientX, y: e.clientY, gx: CFG.gx || 0, gy: CFG.gy || 0 };
      if (engrave.setPointerCapture) engrave.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    engrave.addEventListener('pointermove', function(e){
      if (!calDrag) return;
      var r = stage.getBoundingClientRect(); if (!r.width || !r.height) return;
      CFG.gx = calDrag.gx + (e.clientX - calDrag.x) / r.width  * 100;
      CFG.gy = calDrag.gy + (e.clientY - calDrag.y) / r.height * 100;
      render(); calShow();
    });
    engrave.addEventListener('pointerup',     function(){ calDrag = null; });
    engrave.addEventListener('pointercancel', function(){ calDrag = null; });
    calSize.addEventListener('input', function(){ CFG.gsize = parseFloat(this.value) || 42; render(); calShow(); });
    calRot.addEventListener('input',  function(){ CFG.grot  = parseFloat(this.value) || 0;  render(); calShow(); });
    calCopy.addEventListener('click', function(){
      var t = 'gravure_x = ' + calR1(CFG.gx) + '\ngravure_y = ' + calR1(CFG.gy) +
              '\ngravure_size = ' + calR1(CFG.gsize) + '\ngravure_rotation = ' + calR1(CFG.grot);
      var done = function(){
        calCopy.textContent = '✅ Copié !';
        setTimeout(function(){ calCopy.textContent = '📋 Copier les 4 valeurs'; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(t).then(done, done); }
      else { done(); }
    });
  }

  /* la mesure du texte n'est fiable qu'une fois Sacramento chargée */
  if (document.fonts && document.fonts.load){
    document.fonts.load('200px Sacramento').then(render).catch(render);
    document.fonts.ready.then(render);
  }
  render();
  }
  var q = window.biwNPQ || [];
  window.biwNPQ = { push: function(u){ init(u); } };
  for (var i = 0; i < q.length; i++) init(q[i]);
})();
